import { PaletteOptions } from "./interface";

const palettes = [
	{
		idColor:PaletteOptions.SCOREPLAN,
		colors: [
			"rgba(83, 86, 135, 1)", 
			"rgba(186, 85, 107,  1)", 
			"rgba(127, 156, 150,  1)", 
			"rgba(155, 155, 155,  1)", 
			"rgba(71, 168, 189,  1)", 
			"rgba(91, 46, 72,  1)",  
			"rgba(195, 169, 149,  1)", 
			"rgba(239, 131, 84,  1)"
		]
	},
	{
		idColor:PaletteOptions.VINTAGE,
		colors: [
			"rgb(222, 164, 132)", 
			"rgb(239, 197, 156)", 
			"rgb(203, 113, 94)", 
			"rgb(235, 150, 146)", 
			"rgb(168, 92, 76)",
			"rgb(242, 192, 181)", 
			"rgb(201, 99, 116)", 
			"rgb(221, 149, 108)"
		]
	},
	{
		idColor:PaletteOptions.VIOLET,
		colors: [
			"rgb(209, 161, 209)", 
			"rgb(238, 172, 197)", 
			"rgb(123, 86, 133)", 
			"rgb(126, 124, 173)", 
			"rgb(161, 61, 115)", 
			"rgb(91, 65, 171)", 
			"rgb(226, 135, 226)", 
			"rgb(104, 156, 193)"
		]
	},
	{
		idColor:PaletteOptions.OFFICE,
		colors: [
			"rgb(95, 139, 149)", 
			"rgb(186, 77, 81)", 
			"rgb(175, 138, 83)", 
			"rgb(149, 95, 113)", 
			"rgb(133, 150, 102)", 
			"rgb(126, 104, 140)"
		]
	},
	{
		idColor:PaletteOptions.SOFT_PASTEL,
		colors: [
			"rgb(96, 166, 159)", 
			"rgb(120, 182, 217)", 
			"rgb(102, 130, 187)", 
			"rgb(163, 113, 130)", 
			"rgb(238, 186, 105)", 
			"rgb(144, 186, 88)",
			"rgb(69, 108, 104)",
			"rgb(117, 101, 164)"
		]
	},
	{
		idColor:PaletteOptions.OCEAN,
		colors: [
			"rgb(117, 192, 153)", 
			"rgb(172, 195, 113)", 
			"rgb(55, 138, 138)", 
			"rgb(95, 162, 106)", 
			"rgb(6, 73, 112)", 
			"rgb(56, 197, 210)",
			"rgb(0, 167, 198)",
			"rgb(111, 132, 187)"
		]
	}
];

export const palettesOptions = [
	{ value: PaletteOptions.SCOREPLAN, label: "Scoreplan" },
	{ value: PaletteOptions.OFFICE, label: "Office" },
	{ value: PaletteOptions.VINTAGE, label: "Vintage" },
	{ value: PaletteOptions.VIOLET, label: "Violet" },
	{ value: PaletteOptions.SOFT_PASTEL, label: "Soft Pastel" },
	{ value: PaletteOptions.OCEAN, label: "Ocean" }
];

export default palettes;
